import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "save_doc" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранение заявления", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Введите название файла. Пример: дизайн проект № 643", -1)
const _hoisted_5 = { for: "title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Информация о раннее выданном разрешении", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Введите номер разрешения", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Выберите дату разрешения", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранить заявление разбитый по приложениям", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Сохранить заявление одним файлом", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "right"
}
const _hoisted_15 = { style: {"display":"block"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  style: {"display":"block"},
  for: "name"
}, "Добавить файл к заявлению", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","margin-top":"8px"} }, "Название файла", -1)
const _hoisted_18 = { style: {"margin-top":"96px","width":"330px","display":"inline-block"} }
const _hoisted_19 = { style: {"display":"inline-block"} }
const _hoisted_20 = {
  key: 0,
  style: {"display":"inline-block","margin-bottom":"10px"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { style: {"margin-top":"96px","width":"260px","display":"inline-block","vertical-align":"top"} }
const _hoisted_24 = { style: {"display":"inline-block"} }
const _hoisted_25 = {
  key: 0,
  style: {"display":"inline-block","margin-bottom":"10px"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ModalTariff = _resolveComponent("ModalTariff")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "Введите название файла",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.info_save) = $event))
        }, null, 512), [
          [_vModelText, _ctx.info_save]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("section", null, [
          _createElementVNode("label", _hoisted_5, [
            _createVNode(_component_v_switch, {
              style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
              color: "#2F80ED",
              modelValue: _ctx.document.annotation_yes,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.annotation_yes) = $event)),
              label: "Добавить аннотацию к страницам заявления",
              inline: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.document.annotation_yes == '1')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Введите текст аннотации. Максимальное количество символов: 138"))
          : _createCommentVNode("", true),
        (_ctx.document.annotation_yes == '1')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "input",
              type: "text",
              placeholder: "Введите текст аннотации",
              maxlength: "138",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.annotation) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.document.annotation]
            ])
          : _createCommentVNode("", true),
        (_ctx.document.annotation_yes == '1')
          ? (_openBlock(), _createBlock(_component_MultiSelect, {
              key: 2,
              modelValue: _ctx.document.selected_annotations,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.selected_annotations) = $event)),
              options: _ctx.annotations,
              optionLabel: "name",
              placeholder: "Нажмите для выбора",
              style: {"width":"480px !important"},
              maxSelectedLabels: 3,
              class: "w-full md:w-20rem"
            }, null, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("section", null, [
          _createElementVNode("div", null, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.resolution_number) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.resolution_number]
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              class: "input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.resolution_date) = $event)),
              type: "date",
              placeholder: "__.__.____",
              maxlength: "10",
              onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46"
            }, null, 512), [
              [_vModelText, _ctx.document.resolution_date]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_11,
        _createElementVNode("button", {
          class: "save__application",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.download_separated && _ctx.download_separated(...args)))
        }, "Сохранить по приложениям")
      ]),
      _createElementVNode("div", null, [
        _hoisted_12,
        _createElementVNode("button", {
          class: "save__statement",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.download_all && _ctx.download_all(...args)))
        }, "Сохранить заявление")
      ]),
      (_ctx.load_process)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "loading...",
            class: "loading",
            src: require('../../assets/loading.gif'),
            style: {"width":"20px","height":"20px"}
          }, null, 8, _hoisted_13))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_ModalTariff, {
        is_open: _ctx.modal_end_open,
        key: _ctx.saveIter
      }, null, 8, ["is_open"]))
    ]),
    _createElementVNode("input", {
      ref: "other_files",
      type: "file",
      hidden: "",
      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitFile('other_files', 0, ''))),
      accept: ".pdf,.png,.jpg,.bmp"
    }, null, 544),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("button", {
              style: {"display":"block","margin-top":"8px"},
              class: "add_file_btn",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$refs.other_files.click()))
            }, "Добавить файл"),
            _createElementVNode("div", _hoisted_18, [
              true
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Number(_ctx.document.other_files.length), (n) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (n<7 && _ctx.document.other_files[n-1].name!='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", {
                              class: "filename",
                              style: {"display":"block","cursor":"pointer"},
                              onClick: ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=other_files&element='+(n-1), _ctx.document.proxy_file.split('/')[_ctx.document.proxy_file.split('/').length-1]);}
                            }, _toDisplayString(n) + ". " + _toDisplayString(_ctx.document.other_files[n-1].name), 9, _hoisted_21),
                            _createElementVNode("button", {
                              class: "add_file_btn",
                              onClick: ($event: any) => (_ctx.delete_other_file(n-1)),
                              style: {"display":"block"}
                            }, "Удалить", 8, _hoisted_22)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              true
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Number(_ctx.document.other_files.length), (n) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (n>6 && _ctx.document.other_files[n-1].name!='')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", {
                              class: "filename",
                              style: {"display":"block","cursor":"pointer"},
                              onClick: ($event: any) => {_ctx.downloadFileFromURL('https://api.rekprof.ru/download.php?id='+_ctx.route.query.id+'&hash='+_ctx.route.query.hash+'&type=other_files&element='+(n-1), _ctx.document.other_files[n-1].name);}
                            }, _toDisplayString(n) + ". " + _toDisplayString(_ctx.document.other_files[n-1].name), 9, _hoisted_26),
                            _createElementVNode("button", {
                              class: "add_file_btn",
                              onClick: ($event: any) => (_ctx.delete_other_file(n-1)),
                              style: {"display":"block"}
                            }, "Удалить", 8, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}